<template>
    <time-line
        :itens="itensTimeLine"
    ></time-line>
</template>

<script>
import TimeLine from './../../../../shared/components/TimeLine'

export default {
    components: {
        TimeLine
    },

    props: {
        pagamento: {
            type: Object,
        },

        servicos: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            itensTimeLine: null
        }
    },

    methods: {
        obterTimeLine() {
            this.servicos.obterTimeLine(this.pagamento.pagamentoId).then(response => {
                if (response) {
                    if (response.success) {
                        this.itensTimeLine = response.data
                    } else {
                        this.$toast.error(
                            "Erro ao obter timeline",
                            "ERROR",
                            this.$toastConfig.error
                        );
                    }
                }
            })
        }
    },

    created() {
        this.obterTimeLine()
    },


}

</script>